import { InternalAxiosRequestConfig } from 'axios';
import { Buffer } from 'buffer';

import { storage } from '@percent/hosted-validation-form/utils/storage';

const getToken = () => storage.getItem('jwtToken');

const getPartnerPublicKey = (token: string) => {
  if (token) {
    try {
      return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString()).partnerPublicKey;
    } catch (e) {
      return '';
    }
  }
};

export const requestTokenInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const jwtToken = getToken();

  if (jwtToken) {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: getPartnerPublicKey(jwtToken),
      },
      withCredentials: true,
    } as unknown as InternalAxiosRequestConfig;
  }
  return config;
};
